import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
//import { ErrorHandler } from '../../../shared/ErrorHandler';
import { DatePipe } from '@angular/common';
import { NgForm } from '@angular/forms';
import { UserService } from '../../shared/user.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-schedule-report',
  templateUrl: './schedule-report.component.html',
  styleUrls: ['./schedule-report.component.css']
})
export class ScheduleReportComponent implements OnInit {

  AcountTypelist : any = [];
  LedgerNamesList : any = [];
  branchList : any = [];
  agentList : any = [];
  subLedgerList : any = [];
  data : any = {}
  r : any = {};
  shceduleReportList : any = [];
  branchId : number = 2
  ComputerizedDate = new Date();
  OpenedDate = new Date(1947, 8, 15, 17, 23, 42, 11);;
  categoryList : any = [];
  tablevisi : boolean = false;
  commonUrl : string;
  companylist : any = [];
  userName : any;
  logbranch:any;
  DateValues:string;
  today = new Date(); 


  constructor(private userService: UserService,private router: Router, private route: ActivatedRoute,
    private datepipe: DatePipe ) { 
      this.commonUrl = userService.rootUrl;
      //userName
      console.log('UserName')      ;
      console.log(localStorage.getItem('userName'))
      this.userName = localStorage.getItem('userName');
    }

  ngOnInit() {
    this.logbranch=localStorage.getItem('BRANCH_ID');
    this.getAccountType();
    this.GetAgentData();
    //this.scheduleReport();  
    //this.r.TXVOUCHERDATE = this.newDate ;
    this.r.FromAccountRage = 1;
    this.r.ToAccountRage = 9999999;
    this.r.Ammountrange = -9999999999;
    this.r.ToAmmountrange = 9999999999;
    this.r.InrestRange = 0;
    this.r.ToInrestRange = 99;

    
    this.r.OpenedDate=this.getdatefun('01-01-2000');
    this.r.TXVOUCHERDATE=this.getdatefun(this.today); 
    this.r.ClosedDate =this.getdatefun(this.today); 
    
    
  }

  getdatefun(indt:any)
  {
    debugger;
    this.DateValues=this.datepipe.transform(indt,'yyyy-MM-dd');
    return this.DateValues;
  }

  // scheduleReport(){
  //   this.data = this.userService.scheduleReport();
  //   this.data.subscribe(
  //      (response: any) => {         
  //       this.shceduleReportList= response;        
  //      }
  //   )
  // }

  getAccountType(){
    this.data = this.userService.GetAccountTypeForScheduleReport();
    this.data.subscribe(
       (response: any) => {         
        this.AcountTypelist= response;  
   })

  
       this.data = this.userService.GetAllBranches();
       this.data.subscribe(
          (response: any) => {         
           this.branchList= response;   
           
          }) 
         
          this.data = this.userService.GetCategories();
          this.data.subscribe(
          (response: any) => {         
           this.categoryList= response;           
          }) 
          
          
          this.data = this.userService.GetCaompanies();
          this.data.subscribe(
          (response: any) => {         
           this.companylist= response;      
           console.log('Companies');
           console.log(this.companylist);
          }) 

           
         }

         GetReport(ScheduleReport:NgForm){           
          console.log('Form');
          console.log(ScheduleReport);
          document.getElementById('loader-spinner').style.display = "block";
                this.data = this.userService.scheduleReport(ScheduleReport.value);
                this.data.subscribe(
                (response: any) => { 
                  this.tablevisi = true;        
                this.shceduleReportList= response;    
          document.getElementById('loader-spinner').style.display = "none";    
                },
               (error) => {
                document.getElementById('loader-spinner').style.display = "none";              ;
              }
            )
         }

         ChangeModId(MOD_Id){
           if(MOD_Id >=0){
            this.data = this.userService.GetAllLedgerName(MOD_Id);
            this.data.subscribe(
               (response: any) => {         
                this.LedgerNamesList= response;   
               })
           }                
         }

         ChangeLCode(L_CODE){
          if(L_CODE >=0){
          this.data = this.userService.GetSubLedger(L_CODE);
          this.data.subscribe(
             (response: any) => {         
              this.subLedgerList= response;   
             }) 
            }          
         }

         ChangeBranch(branchId){   
          if(branchId >=0){
           this.data = this.userService.GetAllAgentNames(branchId);
            this.data.subscribe(
             (response: any) => {         
              this.agentList= response;   
             })

             this.data = this.userService.GetComputerizeddate(branchId);
            this.data.subscribe(
             (response: any) => {         
              this.ComputerizedDate= response;  
              console.log('ComputerizedDate');
              console.log(this.ComputerizedDate) ;
              this.r.TXVOUCHERDATE = this.ComputerizedDate;
              this.r.TXVOUCHERDATE = ((this.r.TXVOUCHERDATE).split('T'))[0];
              this.r.ClosedDate = this.ComputerizedDate;
              this.r.ClosedDate = ((this.r.ClosedDate).split('T'))[0];              
             })

             this.r.OpenedDate =this.datepipe.transform(this.OpenedDate, 'yyyy-MM-dd'); 
              //this.r.OpenedDate = ((this.r.OpenedDate).split('T'))[0];
             
         }        
         
         
}

ViewReport(){
  window.open(this.commonUrl+'/Reports/ScheduleReport/schedulereport.aspx?userName='+this.userName+'&branchid='+this.r.BRANCH_ID+'&fromdate='+this.r.OpenedDate+'&todate='+this.r.ClosedDate);
}
GetAgentData(){
  debugger;
this.data = this.userService.GetAllAgents();
this.data.subscribe(
     (response: any) => {         
      this.agentList= response;        
}
) 
}

}
  





// WEBPACK FOOTER //
// ./src/app/reports/schedule-report/schedule-report.component.ts